import loadable from '@loadable/component';

export const PaymentsListContainerLoadable = loadable(
  () => import('./PaymentsListContainer'),
  {
    resolveComponent: (module) => module.PaymentsListContainer,
  },
);
